import * as React from 'react';
const RadioGroupContext = /*#__PURE__*/React.createContext(null);
export const RadioGroupContextProvider = RadioGroupContext.Provider;
export default RadioGroupContext;
export const RadioOptionTypeContext = /*#__PURE__*/React.createContext(null);
export const RadioOptionTypeContextProvider = RadioOptionTypeContext.Provider;